import { Component, OnDestroy } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { Subscription, take } from 'rxjs';
import { UserSettings } from "fakturnia-shared";
import { APIResponse } from 'fakturnia-shared';
import { ApiService } from 'shared/services/api.service';
import { SettingsService } from 'shared/services/settings.service';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { SnackbarService } from 'shared/services/snackbar.service';

@Component({
  standalone: true,
  selector: 'signatures',
  imports: [CommonModule, ReactiveFormsModule, MatSlideToggleModule, MatCheckboxModule, MatInputModule, MatButtonModule],
  templateUrl: './signatures.component.html',
  styleUrls: ['./signatures.component.scss']
})
export class SignaturesComponent implements OnDestroy {

  private _subscriptions: Subscription[] = [];
  signatures = new FormControl(true,[Validators.required]);
  constructor(
    private apiService:ApiService,
    private settingsService:SettingsService,
    private _snackbarService: SnackbarService
  ) {

    this._subscriptions.push(this.settingsService.currentUserSettings.subscribe({
      next: (data: UserSettings)=> {
        this.signatures.setValue(data.settings.autocomplete.signatures, { emitEvent: false})
      }
    }))

    this._subscriptions.push(this.signatures.valueChanges.subscribe(
      (data)=> {
      this.toggleSignatures(data)
    }))
  }

  public toggleSignatures(checked) {
    this.apiService.toggleSignatures(checked)
    .pipe(take(1))
    .subscribe({
      next: (data:APIResponse)=>{
        this.settingsService.refreshSettings()

        if(!data.success) {
          
          this._snackbarService.showSnackBar(
            "Nie udało się zapisać zmian",
            "success", 
            4000
          )

          return
        }

        this._snackbarService.showSnackBar(
          "Zapisano zmiany",
          "success", 
          4000
        )
      }
    })
  }

  ngOnDestroy(): void {
    this._subscriptions.forEach(sub=>sub.unsubscribe())
  }
}

